import { combineDucks } from "lib/utils/duck";

import FinancesListView from "./FinancesListView/index";

export default combineDucks({
  FinancesListView,
});



// WEBPACK FOOTER //
// ./src/modules/finances/index.js